import * as types from "./types";

export default {
  [types.SET_COUPONOBJECT](state, payload) {
    state.currentCouponObject = payload;
  },
  [types.SET_COUPONCODELIST](state, payload) {
    state.couponCodeList = payload;
  }
};
